var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGraceLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.33333H11.3333C11.7015 5.33333 12 5.6318 12 6V12.6667C12 13.0349 11.7015 13.3333 11.3333 13.3333H0.666667C0.29848 13.3333 0 13.0349 0 12.6667V6C0 5.6318 0.29848 5.33333 0.666667 5.33333H1.33333V4.66667C1.33333 2.08934 3.42267 0 6 0C8.57733 0 10.6667 2.08934 10.6667 4.66667V5.33333ZM1.33333 6.66667V12H10.6667V6.66667H1.33333ZM5.33333 8H6.66667V10.6667H5.33333V8ZM9.33333 5.33333V4.66667C9.33333 2.82572 7.84093 1.33333 6 1.33333C4.15905 1.33333 2.66667 2.82572 2.66667 4.66667V5.33333H9.33333Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraceLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GraceLock.ee0dd914.svg";
export { ForwardRef as ReactComponent };